import { Control, Label, TextArea, ControlError } from "@forge/common";
import React, { useRef, useState } from "react";
import { useDispatch } from "react-redux";
import { tenantActions } from "../../../store/Tenant/tenant-slice";
// Adjust the import according to your UI library

interface TextAreaComponentProps {
  setting: any;
  newSettings: any[];
  onInputChange: (
    event: any,
    setting: any,
    productId: string,
    errorMessage: string
  ) => void;
  productId: string;
  settingKeyValidation: any;
}

const TextAreaComponent: React.FC<TextAreaComponentProps> = ({
  setting,
  newSettings,
  onInputChange,
  productId,
  settingKeyValidation,
}) => {
  const errorMessage = useRef(
    newSettings?.find((x: { key: any }) => x.key === setting.key)?.errorMessage
  );
  const [textValue, setTextValue] = useState(
    newSettings?.find((x: { key: any }) => x.key === setting.key)?.value ?? ""
  );
  const dispatch = useDispatch();
  const handleChange = (event: any) => {
    errorMessage.current = settingKeyValidation.onChange(event);

    setTextValue(event.target.value);

    // Calculate the error count and update the store
    let count = 0;
    newSettings.forEach((othersetting: any) => {
      if (othersetting && othersetting.key === setting.key) {
        if (errorMessage.current?.length > 0) {
          count++;
        }
      } else if (othersetting && othersetting?.errorMessage?.length > 0) {
        count++;
      }
    });

    const tabAndError = {
      tabName: productId,
      errorCount: count,
    };
    // Update the error count in the store

    dispatch(tenantActions.updateTabErrorCountMapping(tabAndError as any));
  };

  return (
    <Control>
      <Label requiredText="*"> {setting.displayName} * </Label>
      <TextArea
        {...settingKeyValidation}
        error={Boolean(errorMessage.current)}
        className="settings-textarea"
        id={setting.key}
        name={setting.key}
        required
        value={textValue}
        onChange={handleChange}
        placeholder="Enter a JSON"
        prefixPosition="bottom"
        rows={3}
        size="regular"
        suffixPosition="middle"
        onBlur={() => {
          const newEvent = {
            target: {
              value: textValue,
            },
          };
          onInputChange(newEvent, setting, productId, errorMessage.current);
        }}
        // {...(errorMessage.current && {
        //   error: true,
        // })}
      />
      {errorMessage.current?.length > 0 && (
        <ControlError className="requiredText">
          {errorMessage.current}
        </ControlError>
      )}
    </Control>
  );
};

export default TextAreaComponent;
